import { useEffect, useState, useRef } from "react"
import {server_URL, setSS, getSS, sortingTypes, sortingTypes2, client_url } from ".";
import { Stage, Layer, Rect, Circle, Line } from "react-konva";

import TagMenu from "./TagMenu.js"

function View(){
    const fetchby = useRef(null) // either fetch by *index* or *fileid*
    const disableSwipe = useRef(false)
    const disableDownload = useRef(false)

    const [folderdata,setfolderdata] = useState(null)
    const [folderlens,setfolderlens] = useState(0)

    const [fileID,setFileID] = useState(null)
    const [fileindex,setfileindex] = useState(null)

    const [view,setview] = useState(null)
    const [toupdate,settoupdate] = useState(false)
    const [descriptionText,setdescriptionText] = useState("")
      
    const oldswipingY = useRef(null) // only for mobile
    const swipingY = useRef(null); // only for mobile
    const oldswipingX = useRef(null) // only for mobile
    const Ythreshold = 50 // only for mobile
    const swipingX = useRef(null);

    const swipingThreshold = 50

    const chosentimestamp = useRef([-1,-1])
    const currentvideoid = useRef(null)

    const [tagmenu,settagmenu] = useState(null)
    const [popoutmessage,setpopoutmessage] = useState(null)

    const changesMade = useRef(false)
    const autosaveTimer = 120// 2minutes
    const linesToSave = useRef(null)
    async function autosaveTimerTrigger(){
        setTimeout(()=>{
            autosave()
        },autosaveTimer*1000)
    }
    async function autosave(){
        if(changesMade.current){
            changesMade.current = false
            if(linesToSave.current == [] || linesToSave.current == null){
                return
            }

            const query = new URLSearchParams(window.location.search)
            const response = await fetch(server_URL()+"autosave/"+query.get("cached")+"/"+currentvideoid.current,{
                "method":"POST",
                "headers":{
                    "Content-Type":"application/json",
                },
                "body":JSON.stringify({
                    "content":linesToSave.current
                })
            })
            const output = await response.json()
            setpopoutmessage(
                <div style={{position:"absolute",left:"50%",top:"15px",transform:"translate(-50%,0)",fontWeight:"bold",fontSize:"15px",borderRadius:"5px",background:"lightgray",border:"1px solid black",display:"flex",justifyContent:"center",alignItems:"center"}}>
                    <span style={{margin:"3px"}}>{output["message"]}</span>
                </div>
            )
            setTimeout(()=>{
                setpopoutmessage(null)
            },1500)
        }
        autosaveTimerTrigger()
    }

    
    const [lines, setLines] = useState([])
    const [camera, setCamera] = useState({ x: 0, y: 0 });
    const isDrawing = useRef(false)
    const isPanning = useRef(false)
    const isKonva = useRef(false)
    const lastPos = useRef(null)


    const handlePointerDown = (e) =>{
        if(e.clientX == null){
        swipingX.current = e.touches[0].clientX
        oldswipingX.current = swipingX.current
        swipingY.current = e.touches[0].clientY
        oldswipingY.current = swipingY.current
        }
        else{
        swipingX.current = e.clientX
        }
    }
    const handlePointerUp = (e) =>{
        // if (fetchby.current=="fileid"){
        //     return
        // }
        if(disableSwipe.current){
            return
        }

        let diff = 0
        if(e.clientX == null){
        diff = oldswipingX.current-swipingX.current
        const YDIFF = oldswipingY.current-swipingY.current //MOBILE ONLY
        if((YDIFF>0?YDIFF:YDIFF*-1)>Ythreshold){
            return
        }
        }
        else{
            diff = swipingX.current-e.clientX
        }
        oldswipingX.current = 0
        swipingX.current = 0
        if((diff>0?diff:diff*-1)<=swipingThreshold){
            return
        }

        if(diff<0){ //back
            fileindex-folderlens!=0?setfileindex(prev=>parseInt(prev)-1):""
            return
        }
        if(diff>0){
            fileindex-folderlens!=folderdata.length-1?setfileindex(prev=>parseInt(prev)+1):""
            return
        }
    }
    const handleTouchMove = (e) => {
        swipingX.current = e.touches[0].clientX
        swipingY.current = e.touches[0].clientY
    }
    
    
    const drawingMouseDown = (e) => {
        if (e.evt.button === 2) {
            isPanning.current = true;
            lastPos.current = e.target.getStage().getPointerPosition();
            return;
        } // panning
        if (e.evt.button === 0) {
            isDrawing.current = true;

            const point = e.target.getStage().getPointerPosition();

            const worldX = point.x - camera.x;
            const worldY = point.y - camera.y;

            setLines(prev => [
                ...prev,
                {
                    points: [worldX, worldY]
                }
            ]);
            return;
        } // drawing
    };
    const drawingMouseMove = (e) => {
        if (isPanning.current) {
            const pos = e.target.getStage().getPointerPosition();

            const dx = pos.x - lastPos.current.x;
            const dy = pos.y - lastPos.current.y;

            setCamera(prev => ({
                x: prev.x + dx,
                y: prev.y + dy
            }));

            lastPos.current = pos;
            return;
        }
        if (isDrawing.current){
            const stage = e.target.getStage();
            const point = stage.getPointerPosition();

            const worldX = point.x - camera.x;
            const worldY = point.y - camera.y;

            setLines(prev => {
                const lastLine = {
                    ...prev[prev.length - 1]
                };

                lastLine.points = [
                    ...lastLine.points,
                    worldX,
                    worldY
                ];

                return [
                    ...prev.slice(0, -1),
                    lastLine
                ];
            });
        }
    };
    const drawingMouseUp = (e) => {
        if(isDrawing.current) changesMade.current = true
        isDrawing.current = false
        isPanning.current = false
    };


    function setErrorView(value){
        let name = value+"error.png"
        setview(<div style={{width:"100%",height:"100%",display:"flex",alignContent:"center",justifyContent:"center",background:"#FCFAFD"}}>
            <img style={{width:"20%",objectFit:"contain"}} src={server_URL()+"fetchcontent/gallery-assests/"+name}></img>
        </div>)
    }
    async function keydown(e){
        if(e.key!=="Escape"){
            return
        }

        const query = new URLSearchParams(window.location.search)
        
        await fetch(server_URL()+"updatefiledescription",{
        method:"POST",
        headers:{
            "Content-Type":"application/json",
        },
        body:JSON.stringify({
            "user_cache":query.get("cached"),
            "fileid":folderdata[fileindex-folderlens],
            "newdescription":descriptionText,
        })
        })
        setdescriptionText("")
        settoupdate(false)

        const output = await fetchcontentfunction()
        if(output["status"]!=200){
            setErrorView(output["status"])
            console.log(output["message"])
            return
        }
        document.getElementById("textdata").textContent = output["message"]["file_text"]
    }

    function timeformat(value){
        let first = Math.floor(value / 60)
        let hour = ""
        let minute = first+":"
        if (first>60){
            hour = Math.floor(first/60)+":"
            minute = Math.floor(first % 60)+":"
        }
        if(hour!=""){
            if(hour.length!=3){
                hour = "0"+hour
            }
        }
        let second = Math.floor(value % 60)+"";
        return ("s - "+hour+(minute.length==3?minute:"0"+minute)+(second.length==2?second:"0"+second))
    }

    async function fetchcontentfunction(){

        let fileidvalue = fetchby.current=="fileid"?fileID:folderdata[fileindex-folderlens]

        const response = await fetch(server_URL()+"fetchcontentdata",{
            "method":"POST",
            "headers":{
                "Content-Type":"application/json",
            },
            "body":JSON.stringify({
                "user_cache":new URLSearchParams(window.location.search).get("cached"),
                "fileid":fileidvalue
            })
        })
        return response.json()
    }
    async function fetchcontent() {
        setview(null)
        if(folderdata==null&&fileID==null){
            return
        }
        const query = new URLSearchParams(window.location.search)

        const output = await fetchcontentfunction()

        if(output["status"]!=200){
            setErrorView(output["status"])
            console.log(output["message"])
            return
        }

        const filedata = output["message"]

        
        currentvideoid.current = filedata["id"]

        let contentDisplay = null
        if(filedata["property"].split("/")[0]=="video"){
            contentDisplay = <video id="myVideo" key={fileindex} controls muted autoPlay style={{maxWidth:"80%",height:"90%",objectFit:"contain",margin:"5px"}}>
                <source src={server_URL()+"fetchcontent/"+query.get("cached")+"/"+filedata["id"]}></source>
            </video>
        }
        if(filedata["property"].split("/")[0]=="image"){
            const finalurl = server_URL()+"fetchcontent/"+query.get("cached")+"/"+filedata["id"]
            contentDisplay = <img id="myImage" draggable={false} key={fileindex} style={{maxWidth:"80%",height:"90%",objectFit:"contain",margin:"5px"}} src={finalurl}></img>
        }
        if(filedata["property"].split("/")[0]=="text"){
            const textString = server_URL()+"fetchcontent/"+query.get("cached")+"/"+filedata["id"]
            const response = await fetch(textString)
            const output = await response.text()

            contentDisplay = <textarea id={filedata["id"]} defaultValue={output} style={{width:"90%",height:"98%",margin:"5px"}} onKeyDown={(e)=>{changesMade.current = true; linesToSave.current = e.currentTarget.value}}></textarea>
            disableSwipe.current = true
            disableDownload.current = true
            autosaveTimerTrigger()
        }
        if(filedata["property"].split("/")[0]=="drawing"){
            const drawingPoints = server_URL()+"fetchcontent/"+query.get("cached")+"/"+filedata["id"]
            const response = await fetch(drawingPoints)
            const output = await response.json()

            if(Object.keys(output).length > 0){
                setLines(output)
            }

            isKonva.current = true
            disableSwipe.current = true
            disableDownload.current = true
            autosaveTimerTrigger()
        }

        let filesizestring = ""
        let symbol = ["KB","MB","GB"]
        let divident = 1024
        for(let i=0;i<symbol.length;i++){
            const conversion = (filedata["file_size"]/divident).toFixed(2)
            if(conversion<0.01){
                break
            }
            filesizestring = conversion+" "+symbol[i]
            divident*=1024
        }

        const alltagsdiv = []
        const alltags = filedata["tags"]
        for(const tagarr of alltags){
            alltagsdiv.push(
                <div key={tagarr[2]} style={{width:"fit-Content",height:"fit-content",borderRadius:"5px",margin:"1px",cursor:"pointer",borderRadius:"3px",background:"lightgray",display:"flex",justifyContent:"center",alignItems:"center",border:"1px solid black"}}>
                    <span style={{marginLeft:"2px",marginRight:"2px",marginTop:"1px",marginBottom:"1px"}} onClick={()=>{
                        setSS("tags",""+tagarr[2])
                        window.location.href = client_url()+"Tag?cached="+(new URLSearchParams(window.location.search)).get("cached")
                    }}>{tagarr[0]} ({tagarr[1]})</span>
                </div>
            )
        }
        if(alltagsdiv.length===0){
            alltagsdiv.push(
                <span style={{marginLeft:"5px",color:"red"}}>no tags set</span>
            )
        }
        

        setview(
        <div style={{width:"100%",height:"fitContent",display:"flex",flexDirection:"column-reverse",position:"relative",overflowY:"auto"}}>
            <div style={{width:"100%",height:"fit-Content",display:"flex",flexDirection:"column",gap:"3px"}}>
                <div style={{display:"flex",alignItems:"center"}}>
                    {/* <img style={{width:"20px",height:"20px",objectFit:"contain",left:"4px",top:"4px",borderRadius:"5px",cursor:"pointer",margin:"5px"}} src={server_URL()+"fetchcontent/gallery-assests/Timer.png"} onClick={(e)=>{
                        if(document.getElementById("myVideo")==null){
                            return
                        }
                        const video = document.getElementById("myVideo")
                        const currenttime = video.currentTime
                        const arr = chosentimestamp.current
                        if(arr[0]==-1){
                            arr[0] = currenttime

                        }
                        else{
                            if(arr[1]==-1){
                                arr[1] = currenttime
                                if(arr[1]<=arr[0]){
                                    arr[0] = currenttime
                                    arr[1] = video.duration
                                }
                            }
                            else{
                                arr[0] = -1
                                arr[1] = -1
                            }
                        }
                        if(arr[0]==-1){
                            document.getElementById("timeframemarker").textContent = ""
                            return
                        }
                        arr[2] = video.duration
                        const c1 = timeformat(arr[0])
                        const c2  = timeformat(arr[1]==-1?video.duration:arr[1])
                        document.getElementById("timeframemarker").textContent = c1+"\n"+c2

                        // let first = Math.floor(arr[0] / 60)
                        // let cur_hour = ""
                        // let cur_minutes = first+":"
                        // if (first>60){
                        //     cur_hour = Math.floor(first/60)+":"
                        //     cur_minutes = Math.floor(first % 60)+":"
                        // }
                        // if(cur_hour!=""){
                        //     if(cur_hour.length!=3){
                        //         cur_hour = "0"+cur_hour
                        //     }
                        // }
                        // let cur_seconds = Math.floor(arr[0] % 60)+"";
                        // const cur_output = cur_hour+(cur_minutes.length==3?cur_minutes:("0"+cur_minutes))+(cur_seconds.length==3?cur_seconds:("0"+cur_seconds))
                        
                        // let second = arr[1]==-1?Math.floor(video.duration / 60):Math.floor(arr[1] / 60)
                        // let end_hour = ""
                        // let end_minutes = second+":"
                        // if (second>60){
                        //     end_hour = Math.floor(second/60)+":"
                        //     end_minutes = Math.floor(second % 60)+":"
                        // }
                        // if(end_hour!=""){
                        //     if(end_hour.length!=3){
                        //         end_hour = "0"+end_hour
                        //     }
                        // }
                        // let end_seconds = Math.floor(arr[0] % 60)+"";
                        // const end_output = end_hour+(end_minutes.length==3?end_minutes:("0"+end_minutes))+(end_seconds.length==3?end_seconds:("0"+end_seconds))


                    }}></img> */}
                    <pre id="timeframemarker" style={{height:"fit-Content",width:"fit-Content",margin:"5px"}}></pre>
                    <img style={{width:"20px",height:"20px",objectFit:"contain",left:"4px",top:"4px",borderRadius:"5px",cursor:"pointer",margin:"5px",display:disableDownload.current?"none":"flex"}} src={server_URL()+"fetchcontent/gallery-assests/Download.png"} onClick={(e)=>{
                        if(disableDownload.current){
                            return
                        }
                        let contentype = "image"
                        if(document.getElementById("myVideo")!=null){
                            contentype = "video"
                        }
                        const timestamp = chosentimestamp.current
                        downloadcontent(contentype,timestamp)
                    }}></img>
                </div>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",cursor:"default",marginLeft:"2px"}}>Name:</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontSize:"12px",width:"fit-Content",marginLeft:"2px",whiteSpace:"nowrap",marginRight:"2px"}}>{filedata["name"]}</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",cursor:"default",marginLeft:"2px"}}>id:</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontSize:"12px",width:"fit-Content",marginLeft:"2px",whiteSpace:"nowrap",marginRight:"2px"}}>{filedata["id"]}</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",cursor:"default",marginLeft:"2px"}}>Type:</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontSize:"12px",width:"fit-Content",marginLeft:"2px",whiteSpace:"nowrap",marginRight:"2px"}}>{filedata["property"]}</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",cursor:"default",marginLeft:"2px"}}>Creation:</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontSize:"12px",width:"fit-Content",marginLeft:"2px",whiteSpace:"nowrap",marginRight:"2px"}}>{filedata["date_created"]}</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontWeight:"bold",fontSize:"14px",cursor:"default",marginLeft:"2px"}}>Size:</span>
                <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontSize:"12px",width:"fit-Content",marginLeft:"2px",whiteSpace:"nowrap",marginRight:"2px"}}>{filesizestring}</span>
                <div style={{fontWeight:"bold",cursor:"default",marginLeft:"2px",display:"flex",alignItems:"center"}}>
                    <span style={{fontFamily:"Helvetica, Arial, sans-serif",fontSize:"14px",marginRight:"5px"}}>Tags:</span>
                    <span style={{height:"14px",width:"17px",borderRadius:"7px",background:"gray",display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}} onClick={()=>{
                        settagmenu(
                            <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px",background:"rgba(0.5,0.5,0.5,0.5)",zIndex:"400"}}>
                                <img style={{position:"absolute",left:"5px",top:"5px",width:"20px",height:"20px",objectFit:"contain",background:"white",borderRadius:"5px",cursor:"pointer"}} src={server_URL()+"fetchcontent/gallery-assests/Cancel.png"} onClick={()=>{
                                    settagmenu(null)
                                }}></img>
                                <TagMenu fileID={filedata["id"]} toClose={(message)=>{
                                    settagmenu(null)
                                    setpopoutmessage(
                                        <div style={{position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",fontWeight:"bold",fontSize:"15px",borderRadius:"5px",background:"lightgray",border:"1px solid black",display:"flex",justifyContent:"center",alignItems:"center"}}>
                                            <span style={{margin:"3px"}}>{message}</span>
                                        </div>
                                    )
                                    setTimeout(()=>{
                                        setpopoutmessage(null)
                                    },1500)
                                }}/>
                            </div>
                        )
                    }}>+</span>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",width:"100%",height:"fit-content",fontFamily:"Helvetica, Arial, sans-serif",fontSize:"10px"}}>
                    {alltagsdiv}
                </div>
                
                <pre style={{marginLeft:"2px",marginRight:"2px",height:"fit-Content",textWrap:"wrap"}}  onClick={()=>{
                    setdescriptionText(filedata["file_text"])
                    settoupdate(true)
                }}>
                    <code id="textdata">{filedata["file_text"]==""?"(no description)":filedata["file_text"]}</code>
                </pre>
            </div>
            <div id="contentdisplay" style={{position:"relative",width:"100%",height:"calc(var(--vh, 1vh) * 100)",minHeight:"calc(var(--vh, 1vh) * 100)",display:!isKonva.current?"flex":"none",justifyContent:"center",background:"black"}} onTouchStart={handlePointerDown} onTouchEnd={handlePointerUp} onTouchMove={handleTouchMove} onPointerDown={handlePointerDown} onPointerUp={handlePointerUp}>
                {contentDisplay}
            </div>
        </div>)
    }
    async function folderdatafunc(){
        if (fetchby.current=="fileid"){
            return
        }
        const query = new URLSearchParams(window.location.search)
        const response = await fetch(server_URL()+"fetchfolderdata",{
            "method":"POST",
            "headers":{
                "Content-Type":"application/json",
            },
            "body":JSON.stringify({
                "user_cache":query.get("cached"),
                "folderid":query.get("folder"),
                "sorting":[sortingTypes[parseInt(getSS("sortingtype"))],sortingTypes2[parseInt(getSS("sortingtype2"))]]
            })
        })
        const output = await response.json()
        if(output["status"]!=200){
            setErrorView(output["status"])
            console.log(output["message"])
            return
        }
        setfolderdata(output["filedata"])
        setfolderlens(output["folderslen"])
    }

    async function downloadcontent(contentype,timestampdata){
        const query = new URLSearchParams(window.location.search)
        const response = await fetch(server_URL()+"fetchcontentdata",{
            "method":"POST",
            "headers":{
                "Content-Type":"application/json",
            },
            "body":JSON.stringify({
                "user_cache":query.get("cached"),
                "fileid":currentvideoid.current
            })
        })
        const output = await response.json()
        if(output==null){
            console.log("output is null")
            return
        }
        if(output["status"]!=200){
            console.log(output["status"]+"\n"+output["message"])
            return
        }

        let extention = ""
        // if(contentype=="video"){
        //     extention = "?ts="+timestampdata[0]+"("+timestampdata[1]+"("+timestampdata[2]
        // }

        const filedata = output["message"]
        const downloadUrl =
            server_URL() +
            "fetchcontent/" +
            query.get("cached") +
            "/$$DOWNLOAD$$" +
            filedata["id"] +
            extention;

        window.location.href = downloadUrl;
    }
    
    useEffect(()=>{
        const query = new URLSearchParams(window.location.search)
        if (query.get("cached")==null||query.get("folder")==null){
            setErrorView("404")
            return
        }
        if(query.get("index")==null){
            fetchby.current = "fileid"
            disableSwipe.current = true
            setFileID(query.get("fileid"))
        }
        else if(query.get("fileid")==null){
            fetchby.current = "index"
            setfileindex(query.get("index"))
        }
        else{
            setErrorView("404")
            return
        }
        folderdatafunc()

        
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === "z") {
                e.preventDefault();

                setLines(prev => prev.slice(0, -1));
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => window.removeEventListener("keydown", handleKeyDown);
    },[])
    useEffect(()=>{
        if(!isKonva.current) return
        linesToSave.current = lines
    },[lines])
    useEffect(()=>{
        if(folderdata==null||fileindex==null){
            if(fileID==null){
                return
            }
        }
        fetchcontent()
    },[folderdata,fileindex,fileID])
    useEffect(() => {
        const value = document.getElementById("contentdisplay")
        if(value){
            value.scrollIntoView()
        }
    }, [view]); // run whenever contentDisplay changes
    return(
        <div style={{position:"absolute",left:"0px",right:"0px",top:"0px",bottom:"0px"}}>
            <div style={{display:toupdate?"flex":"none",position:"absolute", left:"0px",right:"0px",bottom:"0px",top:"0px",zIndex:"1000",background:"rgba(128, 128, 128, 0.3)",justifyContent:"center",alignItems:"center"}}>
                <textarea value={descriptionText} onChange={(e)=>setdescriptionText(e.target.value)} style={{width:"200px",height:"400px"}} onKeyDown={(e)=>{keydown(e)}}/>
                <div style={{position:"absolute",top:"10px",right:"10px",border:'2px solid black',borderRadius:"5px",zIndex:"1000",width:"20px",height:"20px",background:"white",cursor:"pointer"}} onClick={(e)=>{
                    settoupdate(false)
                }}>
                    <img style={{maxWidth:"100%",maxWidth:"100%",objectFit:"contain"}} src={server_URL()+"fetchcontent/gallery-assests/Cancel.png"}></img>
                </div>
            </div>
            <Stage width={window.innerWidth} height={window.innerHeight*0.99} style={{display:isKonva.current?"flex":"none",border:"5px solid black"}} onMouseDown={drawingMouseDown} onMouseMove={drawingMouseMove} onMouseUp={drawingMouseUp} onMouseLeave={drawingMouseUp} 
                    onContextMenu={(e) => {
                        e.evt.preventDefault();
                    }}>
                <Layer x={camera.x} y ={camera.y}>
                    {lines.map((line, i) => (
                        <Line
                            key={i}
                            points={line.points}
                            stroke="black"
                            strokeWidth={3}
                            tension={0.5}
                            lineCap="round"
                            lineJoin="round"
                        />
                        ))}
                </Layer>
            </Stage>
            {view}
            {tagmenu}
            {popoutmessage}
        </div>
    )
}

export default View